export default __webpack_public_path__ + "static/media/pof-bankStatement.43bcbbb4.png";